import { render } from "@react-three/fiber";
import React, {useState} from "react";
import FormControl from 'react-bootstrap/Form'
import Dropdown from 'react-bootstrap/Dropdown'

const options = [
    {name: "alternative"},
    {name: "art"},
    {name: "australian"},
    {name: "australiana"},
    {name: "buddhism"},
    {name: "cassettes"},
    {name: "CDs"},
    {name: "chemistry"},
    {name: "classics"},
    {name: "collectors"},
    {name: "comics"},
    {name: "cooking"},
    {name: "crime"},
    {name: "detective"},
    {name: "display"},
    {name: "DVDs"},
    {name: "ecology"},
    {name: "family"},
    {name: "fantasy"},
    {name: "fashion"},
    {name: "feminism"},
    {name: "film"},
    {name: "foreignLanguage"},
    {name: "garden"},
    {name: "generalFiction"},
    {name: "geology"},
    {name: "guitarMags"},
    {name: "health"},
    {name: "history"},
    {name: "homecraft"},
    {name: "horror"},
    {name: "historical"},
    {name: "kids"},
    {name: "magazines"},
    {name: "martialArts"},
    {name: "math"},
    {name: "modernClassics"},
    {name: "nature"},
    {name: "photography"},
    {name: "physics"},
    {name: "poetry/plays"},
    {name: "politics"},
    {name: "scifi"},
    {name: "speculative"},
    {name: "sheetMusic"},
    {name: "space"},
    {name: "sport"},
    {name: "textbooks"},
    {name: "theology"},
    {name: "trade"},
    {name: "travel"},
    {name: "trueCrime"},
    {name: "trueWar"},
    {name: "vinyl"},
    {name: "vinylDisplay"},
    {name: "westerns"},
]

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      &#x25bc;
    </a>
  ));

  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
      const [value, setValue] = useState('');

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <FormControl
            className="mx-3 my-2 w-auto"
            placeholder="Type to filter..."
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
          <ul className="list-unstyled">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value),
            )}
          </ul>
        </div>
      );
    },
  );
export const OptionsMenu = ({activeOption, setActiveOption, selectSwatch}) => {

    const [theActive, setActive] = useState("");

    const [drawerClass, setDrawerClass] = useState("");

    function sectionClick(name) {
        setDrawerClass("closedDrawer")
        setActive(name)
      selectSwatch(name)
    }

    function openClick() {
        setDrawerClass("openDrawer")
    }



    return(
        /*
        <Dropdown>
    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
      Find a section
    </Dropdown.Toggle>

    <Dropdown.Menu as={CustomMenu}>

    {options.map(({name}, idx) => (
        <Dropdown.Item data-option={name}
        onClick={() => selectSwatch(name)}
        key={name}>{name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).replace(/([A-Z])\s(?=[A-Z])/g, '$1')}</Dropdown.Item>
    ))}
    </Dropdown.Menu>
  </Dropdown>
   */
    <div>
        <div className="widerTop"><a href="https://ricesbookshop.com"><img src={process.env.PUBLIC_URL +'/logo.png'} className="navLogo" /></a></div>
        <div id="menuDrawer">
            <a href="https://ricesbookshop.com"><img src={process.env.PUBLIC_URL +'/logo.png'} className="navLogo" /></a>
            <div className="browse" onClick={() => openClick()}>▼ browse store{theActive == "" ? "" : " - "  + theActive.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).replace(/([A-Z])\s(?=[A-Z])/g, '$1')}</div>
        </div>
        <div className={`sideMenu ${drawerClass}`}>
            <div><b>Find a section</b></div>
            {options.map(({name}, idx) => (
            <div className={`option ${theActive == name ? "--is-active" : ""}`}
            data-option={name}
            key={name}
            onClick={() => sectionClick(name)}>{name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).replace(/([A-Z])\s(?=[A-Z])/g, '$1')}</div>
            ))}
        </div>
    </div>
  )


}